let assetUrl = window.APP_CONFIG.assetUrl ? window.APP_CONFIG.assetUrl : ''

// define constants for config injected from environment
export const API_URL = window.APP_CONFIG.apiUrl ? window.APP_CONFIG.apiUrl : null
export const ASSET_URL = window.APP_CONFIG.assetUrl ? window.APP_CONFIG.assetUrl : null
export const STRIPE_API_KEY = window.APP_CONFIG.stripeApiKey ? window.APP_CONFIG.stripeApiKey : null
export const TOKBOX_API_KEY = window.APP_CONFIG.tokboxApiKey ? window.APP_CONFIG.tokboxApiKey : null
export const DEEPLINK_BRANCK_URL = window.APP_CONFIG.deeplinkBranchURL ? window.APP_CONFIG.deeplinkBranchURL : null
export const DEFAULT_LOCALE = window.APP_CONFIG.locale ? window.APP_CONFIG.locale : null
export const VERSION = window.APP_CONFIG.version ? window.APP_CONFIG.version : 'dev'
export const SENTRY_DSN = window.APP_CONFIG.sentryDSN ? window.APP_CONFIG.sentryDSN : null 
export const SENTRY_ENVIRONMENT = window.APP_CONFIG.sentryEnvironment ? window.APP_CONFIG.sentryEnvironment : null 
export const REDIRECT_URL = window.APP_CONFIG.redirectURL ? window.APP_CONFIG.redirectURL : null
export const WEB_APP_URL = window.APP_CONFIG.webAppURL ? window.APP_CONFIG.webAppURL : null

export const SCHEDULE = {
  MIN_DURATION: 30, // minimum duration to schedule a call in minutes
  MAX_DURATION: 360, // maximum duration to schedule a call in minutes
  PRE_SCHEDULE_LIMIT: 720 // minimum time limit to schedule a future call in minutes
}

export const DURATION = {
  MILLISECOND: 1,
  SECOND: 1000,
  MINUTE: 1000 * 60,
  HOUR: 1000 * 60 * 60,
  DAY: 1000 * 60 * 60 * 24
}

export const CACHE = {
  CLIENT_CONFIG: 5 * DURATION.MINUTE // used to throttle reloading billing account account configuration
}

export const JWT_REFRESH_INTERVAL = 10 * DURATION.MINUTE

// These flags are also defined in the api. Changes to format must be made in both places
//Linguist Classification
export const featureFlagIsBlockedUser = "users:blocked"

export const featureFlagActiveLinguist      = "users:active-linguist"
export const featureFlagProspectiveLinguist = "users:prospective-linguist"
export const featureFlagTestCallLinguist    = "users:test-call-linguist"

	//Linguist Steps Flags - these are *not* mutually exclusive. These will measure a linguist's progress through the activation process
export const	featureFlagLinguistActivationSelfAssessment      = "linguist-activation:self-assessment-completed"
export const	featureFlagLinguistActivationOrientation         = "linguist-activation:orientation-completed"
export const	featureFlagLinguistActivationTrialCallCompleted  = "linguist-activation:trial-call-completed"
export const 	featureFlagLinguistActivationServiceAgreement    = "linguist-activation:service-agreement-completed"
export const  featureFlagLinguistActivationTestCallCompleted   = "linguist-activation:test-call-completed"
export const  featureFlagLinguistActivationEligibilityCompleted = "linguist-activation:eligibility-completed"
export const  featureFlagLinguistActivationAgreementsCompleted  = "linguist-activation:agreements-completed"

// Healthcare Agreements
export const featureFlagAgreementLinguistHCBAA = "agreements:linguist-healthcare-baa"
export const featureFlagAgreementLinguistHCHIPPAPolicy = "agreements:linguist-healthcare-hipaa-policy"

// Medically Active
export const featureFlagLinguistTagAseEngMedicalActive = "linguists:tag:eng+spa:medical-active"
export const featureFlagLinguistTagEngSpaMedicalActive = "linguists:tag:ase+eng:medical-active"

export const LinguistActivationSteps = [
  featureFlagLinguistActivationSelfAssessment,
  featureFlagLinguistActivationOrientation,
  featureFlagLinguistActivationTestCallCompleted,
  featureFlagLinguistActivationEligibilityCompleted,
  featureFlagLinguistActivationAgreementsCompleted
]

//Trial Period and Eligibility are Mutex
export const	featureFlagLinguistActivationTrialPeriod  = "linguist-activation:trial-period-active"
export const	featureFlagLinguistEligibilityMet         = "linguist-activation:eligibility-met"

export const CUSTOMER_FREE_MINUTES = 5

// export const serviceWorkerFile = !!window.APP_CONFIG.assetUrl ? '../../dist/firebase-messaging-sw.js' : assetUrl +'/dist/static/firebase-messaging-sw.js'

export const defaultAvatarURL = 'https://www.gravatar.com/avatar/?d=mp&s=250';

//Current version of each policy that is currently active are defined
export const privacyPolicy = {
  URL: assetUrl+'/dist/static/docs/en/Jeenie_PP_V1.txt',
  DOWNLOAD: assetUrl+'/dist/static/docs/en/Jeenie_PP_V1.pdf',
  VERSION: 'v1',
  AGREEMENT: 'privacyPolicy',
  TITLE: "Jeenie_Privacy_Policy"
}

export const termsOfUse = {
  URL: assetUrl+'/dist/static/docs/en/Jeenie_ToU_V1.txt',
  DOWNLOAD: assetUrl+'/dist/static/docs/en/Jeenie_ToU_V1.pdf',
  VERSION: 'v1',
  AGREEMENT: 'termsOfUse',
  TITLE: 'Jeenie_Terms_Of_Use'
}

export const serviceAgreement = {
  URL: assetUrl+'/dist/static/docs/en/Jeenie_LSA_V1.txt',
  DOWNLOAD: assetUrl+'/dist/static/docs/en/Jeenie_LSA_V1.pdf',
  VERSION: 'v1',
  AGREEMENT: 'linguistServiceAgreement',
  TITLE: 'Jeenie_Platform_Service_Agreement'
}

export const linguistHealthcareBAA = {
  URL: assetUrl+'/dist/static/docs/en/Jeenie_HC_BAA_V1.txt',
  DOWNLOAD: assetUrl+'/dist/static/docs/en/Jeenie_HC_BAA_V1.pdf',
  VERSION: 'v1',
  AGREEMENT: 'linguistHealthcareBAA',
  TITLE: 'Jeenie_Linguist_Healthcare_BAA'
}

export const linguistHIPAAPolicy = {
  URL: assetUrl+'/dist/static/docs/en/Jeenie_HC_HIPAA_V1.txt',
  DOWNLOAD: assetUrl+'/dist/static/docs/en/Jeenie_HC_HIPAA_V1.pdf',
  VERSION: 'v1',
  AGREEMENT: 'linguistHIPAAPolicy',
  TITLE: 'Jeenie_Linguist_HIPAA_Policy'
}

// Sound files used in project
export const incomingCallSound = {
  URL: assetUrl+'/dist/static/sounds/elastic_musical5.wav',
}

//TODO: Make channel be i18n paths to strings to pass to the translator at render
export const linguistChannels = [
{
  channel: "Another Language Jeenie",
  additionalInformation: "",
  addInfo: true
},
{
  channel: "Colleague or friend",
  additionalInformation: "",
  addInfo: true
},
{
  channel: "Professional association",
  additionalInformation: "",
  addInfo: true
},
{
  channel: "University or school",
  additionalInformation: "",
  addInfo: true
},
{
  channel: "Social media",
  additionalInformation: "",
  addInfo: false
},
{
  channel: "Direct mail",
  additionalInformation: "",
  addInfo: false
},
{
  channel: "Advertisement",
  additionalInformation: "",
  addInfo: false
},
{
  channel: "ProZ",
  additionalInformation: "",
  addInfo: false
},
{
  channel: "ACTFL",
  additionalInformation: "",
  addInfo: false
},
{
  channel: "NAFSA",
  additionalInformation: "",
  addInfo: false
},
{
  channel: "NCLC",
  additionalInformation: "",
  addInfo: false
},
{
  channel: "Other",
  additionalInformation: "",
  addInfo: true
}
]

export const linguistStatusi = [
  {
    status: "Interpreter",
    additionalInformation: ""
  },
  {
    status: "Translator",
    additionalInformation: ""
  },
  {
    status: "Teacher or professor",
    additionalInformation: ""
  },
  {
    status: "Other employed professional",
    additionalInformation: ""
  },
  {
    status: "Student",
    additionalInformation: ""
  },
  {
    status: "Retired",
    additionalInformation: ""
  },
  {
    status: "Other",
    additionalInformation: ""
  }
]

export const VIDEO_ONLY_LANG_CODES = [
  'ase',
  'ugn',
  'xki'
]

export const PRIMARY_LANG_CODES = [
  "eng",
  "ase",
  "bem",
  "bib",
  "cmn",
  "yue",
  "arz",
  "apd",
  "tois1237",
  "zho-cn-shang",
  "zho-tw",
  "jpn",
  "spa",
  "spa-r-la",
  "spa-es",
  "deu",
  "fra",
  "fra-ca",
  "fra-fr",
  "arb",
  "aao",
  "ara-arz_apd",
  "afb",
  "acm",
  "ara-apc_ajp",
  "azj",
  "azb",
  "por",
  "por-br",
  "por-pt",
  "rus",
  "ita",
  "kor",
  "nld",
  "swe",
  "nor",
  "tur",
  "pol",
  "dan",
  "fin",
  "tha",
  "heb",
  "ind",
  "pes",
  "prs",
  "hin",
  "ces",
  "zsm",
  "pus",
  "sin",
  "mah",
  "ell",
  "hun",
  "ron",
  "vie",
  "ben",
  "cat",
  "fil",
  "tam",
  "slk",
  "kaz",
  "ltz",
  "kur",
  "ukr",
  "afr",
  "hrv",
  "glg",
  "slv",
  "lit",
  "ckb",
  "jav",
  "urd",
  "sqi",
  "tel",
  "srp",
  "yor",
  "hau",
  "bul",
  "uzb",
  "swa",
  "eus",
  "bel",
  "tat",
  "amh",
  "bos",
  "mya",
  "kea",
  "guj",
  "hat",
  "hmn",
  "khm",
  "lao",
  "npi",
  "som",
  "tgl",
  "tir",
  "lin",
  "orm",
  "ksw",
  "eky",
  "wol",
  "kin",
  "jam",
  "quc",
  "mam",
  "tzo",
  "kjb",
  "mon",
  "run",
  "pan",
  "que",
  "knj",
  "mixt1427",
  "kek",
  "aym",
  "cak",
  "ixi",
  "acr",
  "cac",
  "yua",
  "zap",
  "poh",
  "poc",
  "usp",
  "agu",
  "nav",
  "cnh",
  "ibo",
  "ceb",
  "zom",
  "rhg",
  "mal",
  "cho",
  "kat",
  "chk",
  "kos",
  "pon",
  "ixj",
  "ixl",
  "hop",
  "haz",
  "aiq",
  "tuk",
  "bal",
  "brh",
  "sot",
  "zul",
  "mar",
  "kan",
  "ori",
  "asm",
  "mai",
  "kun",
  "yid",
  "ugn",
  "xki",
  "jac",
  "aar",
  "skr",
  "hnd",
  "hno",
  "arm",
  "ctu",
  "kbp",
  "kon",
  "tzh",
  "syl",
  "ful",
  "aka",
  "bam",
  "tar",
  "tac",
  "tzj",
  "anu",
  "qug",
  "qxr",
  "qvi",
  "ahi",
  "kro",
  "triq1251",
  "quz",
  "toj",
  "csn",
  "quv",
  "snk",
  "pga",
  "shu",
  "arq",
  "apc",
  "gsw",
  "nds",
  "gcr",
  "psr",
  "nob",
  "nno",
  "hif",
  "psp",
  "hac",
  "zza",
  "kmr",
  "sdh",
  "hbs",
  "bqn",
  "swc",
  "ghk",
  "blk",
  "kvu",
  "kyu",
  "fao",
  "isl",
  "lav",
  "fas",
  "bak",
  "bre",
  "cos",
  "div",
  "est",
  "fry",
  "kal",
  "iku",
  "gle",
  "kok",
  "kir",
  "dsb",
  "mkd",
  "mlt",
  "mri",
  "arn",
  "moh",
  "oci",
  "roh",
  "smn",
  "smj",
  "sme",
  "sms",
  "sma",
  "san",
  "gla",
  "nso",
  "tsn",
  "syc",
  "tgk",
  "ber",
  "hsb",
  "uig",
  "cym",
  "sah",
  "iii",
  "bfi",
  "isg",
  "ncs",
  "ewe",
  "gaa",
  "twi",
  "kri",
  "fat",
  "gan",
  "fzho",
  "hak",
  "hokk1242",
  "hsn",
  "pcm",
  "smo",
  "ton",
  "fij",
  "tvl",
  "tpi",
  "gil",
  "sna",
  "grb",
  "syr",
  "ban",
  "bis",
  "ilo",
  "nau",
  "niu",
  "pkp",
  "sun",
  "tah",
  "tkl",
  "pag",
  "nan",
  "fcs",
  "lat",
  "hil",
  "ace",
  "ach",
  "esu",
  "xho",
  "chao1238",
  "ctd",
  "zyp",
  "kdh",
  "din",
  "dyo",
  "bin",
  "gex",
  "gug",
  "hain1238",
  "har",
  "mey",
  "lom",
  "clt",
  "ziw",
  "mkw",
  "kik",
  "jing1262",
  "jra",
  "lug",
  "luo",
  "ymm",
  "mnk",
  "mrh",
  "hlt",
  "myb",
  "men",
  "ium",
  "hna",
  "cnr",
  "nus",
  "wes",
  "fuc",
  "sez",
  "chen1267",
  "sus",
  "bsq",
  "cal",
  "cha",
  "cfm",
  "als",
  "brx",
  "doi",
  "kas",
  "mni",
  "sat",
  "snd",
  "tcs",
  "ulk",
  "wim",
  "mwp",
  "kky",
  "pis",
  "wmt",
  "ggd",
  "yuul1239",
  "new",
  "apa",
  "beq",
  "nya",
  "sfs",
  "nde",
  "ssw",
  "tso",
  "ven",
  "toi",
  "tog",
  "lua",
  "mlg",
  "lrl",
  "mfz",
  "tdt",
  "ood",
  "sag",
  "tig",
  "scn",
  "nyn",
  "kac",
  "spy",
  "kln",
  "sgc",
  "lan",
  "enb",
  "pko",
  "kpz",
  "axe",
  "aly",
  "eth",
  "chat1268",
  "rki",
  "ade",
  "bmb",
  "bua",
  "cre",
  "dgr",
  "kqo",
  "gej",
  "gom",
  "pdu",
  "tod",
  "kxf",
  "mls",
  "dty",
  "pau",
  "pam",
  "pif",
  "krn",
  "kvy",
  "shn",
  "czt",
  "blt",
  "bfz",
  "rkm",
  "agq",
  "emk",
  "aee",
  "glh",
  "psi",
  "psh",
  "ibg",
  "lir",
  "ssy",
  "mlq",
  "pap",
  "tem",
  "krw",
  "waci1238",
  "arc",
  "krj",
  "haw",
  "raj",
  "bete1265",
  "dzo",
  "bgc",
  "bho",
  "mfs",
  "bzj",
  "trf",
  "limo1249",
  "bjs",
  "ktb",
  "hfy",
  "kab",
  "mkj",
  "hgm",
  "dag",
  "ryu",
  "war",
  "csf",
  "nzi",
  "csg",
  "bzs",
  "wuu",
  "ouji1238",
  "xiam1236",
  "bhh",
  "bai",
  "nwe",
  "mos",
  "ssp",
  "cbi",
  "kno",
  "kfr",
  "tiv",
  "byv",
  "mwr",
  "kqs",
  "kss",
  "gru",
  "stv",
  "zwa",
  "ior",
  "mvz",
  "sgw",
  "phr",
  "aaa",
  "gkn",
  "wln",
  "chim1312",
  "ghl",
  "pov",
  "kcm",
  "guz",
  "nap",
  "ning1280",
  "tsz",
  "baju1245",
  "lus",
  "cab",
  "tcf",
  "tpc",
  "tpl",
  "tpx",
  "ttc",
  "nah",
  "amu",
  "azm",
  "azg",
  "czn",
  "cly",
  "cya",
  "dyu",
  "ymn",
  "kam",
  "kxd",
  "mol",
  "dje",
  "keo",
  "aks",
  "bod",
  "msa",
]



export const PRIMARY_LANGUAGES = {
  eng: "English",
  ase: "",
  "bem":"",
  "bib":"",
  cmn: "中文（普通话）",
  yue: "中文（广东话）",
  arz: "",
  apd: "",
  tois1237: "",
  "zho-cn-shang": "上海話",
  "zho-tw": "",
  jpn: "日本語",
  spa: "Español",
  "spa-r-la": "",
  "spa-es": "",
  deu: "Deutsch",
  fra: "Français",
  "fra-ca": "Français canadien",
  "fra-fr": "",
  arb: "عربي ( فصحي)",
  aao: "عربي ( جزائري - مغربي - تونسي)",
  "ara-arz_apd": "عربي ( مصري أو سوداني)",
  afb: "عربي ( خليجي)",
  acm: "عربي ( عراقي)",
  "ara-apc_ajp": "عربي ( شامي)",
  azj: "",
  azb: "",
  por: "Português",
  "por-br": "Português (Brasileiro)",
  "por-pt": "",
  rus: "Русский",
  ita: "Italiano",
  kor: "한국인",
  nld: "",
  swe: "",
  nor: "",
  tur: "Türkçe",
  pol: "Polski",
  dan: "",
  fin: "",
  tha: "แบบไทย",
  heb: "עִברִית",
  ind: "Bahasa Indonesia",
  pes: "فارسی",
  prs: "دری",
  hin: "हिंदी",
  ces: "čeština",
  zsm: "Bahasa Malaysia",
  pus: "پښتو",
  sin: "",
  mah: "",
  ell: "Ελληνικά",
  hun: "Magyar",
  ron: "Română",
  vie: "Tiếng Việt",
  ben: "স্থানীয় মধ্যে",
  cat: "",
  fil: "",
  tam: "தமிழ்",
  slk: "Slovenčina",
  kaz: "",
  ltz: "",
  kur: "Kurdî",
  ukr: "Yкраїнська",
  afr: "",
  hrv: "Hrvatski",
  glg: "",
  slv: "",
  lit: "",
  ckb: "",
  jav: "",
  urd: "اردو",
  sqi: "Shqip",
  tel: "తెలుగు",
  srp: "Српски",
  yor: "Èdè Yorùbá",
  hau: "",
  bul: "Bŭlgarski",
  uzb: "",
  swa: "Kiswahili",
  eus: "",
  bel: "",
  tat: "",
  amh: "አማርኛ",
  bos: "Bosanski",
  mya: "မြန်မာ",
  kea: "Kriolu",
  guj: "ગુજરાતી",
  hat: "Kreyòl",
  hmn: "Hmoob",
  khm: "ភាសាខ្មែរ",
  lao: "ພາສາລາວ",
  npi: "नेपाली",
  som: "Soomaali",
  tgl: "",
  tir: "ትግሪኛ",
  lin: "Lingála",
  orm: "Afaan Oromoo",
  ksw: "",
  eky: "Kayah",
  wol: "Làkku Wolof",
  kin: "Kinyarwanda",
  jam: "",
  quc: "K'iche'",
  mam: "Mam",
  tzo: "",
  kjb: "Kanjobal",
  mon: "монгол хэл | ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ",
  run: "Ikirundi",
  pan: "ਪੰਜਾਬੀ",
  que: "",
  knj: "Acateco",
  mixt1427: "",
  kek: "",
  aym: "",
  cak: "",
  ixi: "Nebaj Ixil",
  acr: "Achi'",
  cac: "Chuj",
  yua: "",
  zap: "",
  poh: "",
  poc: "",
  usp: "",
  agu: "",
  nav: "",
  cnh: "",
  ibo: "",
  ceb: "Sugbuanon Binisaya",
  zom: "",
  rhg: "Ruáingga",
  mal: "",
  cho: "",
  kat: "",
  chk: "",
  kos: "",
  pon: "",
  ixj: "",
  ixl: "",
  hop: "",
  haz: "",
  aiq: "",
  tuk: "",
  bal: "",
  brh: "",
  sot: "",
  zul: "",
  mar: "",
  kan: "",
  ori: "",
  asm: "",
  mai: "",
  kun: "",
  yid: "",
  ugn: "",
  xki: "",
  jac: "",
  aar: "",
  skr: "",
  hnd: "",
  hno: "",
  arm: "հայերեն - Hayeren",
  ctu: "",
  kbp: "Kabɩyɛ",
  kon: "",
  tzh: "",
  syl: "ꠍꠤꠟꠐꠤসিলেটি",
  ful: "",
  aka: "",
  bam: "",
  tar: "",
  tac: "",
  tzj: "",
  anu: "",
  qug: "",
  qxr: "",
  qvi: "",
  ahi: "",
  kro: "",
  triq1251: "",
  quz: "",
  toj: "",
  csn: "",
  quv: "",
  snk: "",
  pga: "",
  shu: "",
  arq: "",
  apc: "",
  gsw: "",
  nds: "",
  gcr: "",
  psr: "",
  nob: "",
  nno: "",
  hif: "",
  psp: "",
  hac: "",
  zza: "",
  kmr: "کورمانجی | Kurmancî",
  sdh: "",
  hbs: "",
  bqn: "",
  swc: "",
  ghk: "",
  blk: "",
  kvu: "",
  kyu: "",
  fao: "",
  isl: "",
  lav: "",
  fas: "",
  bak: "",
  bre: "",
  cos: "",
  div: "",
  est: "",
  fry: "",
  kal: "",
  iku: "",
  gle: "",
  kok: "",
  kir: "",
  dsb: "",
  mkd: "македонски јазик",
  mlt: "",
  mri: "",
  arn: "",
  moh: "",
  oci: "",
  roh: "",
  smn: "",
  smj: "",
  sme: "",
  sms: "",
  sma: "",
  san: "",
  gla: "",
  nso: "",
  tsn: "",
  syc: "",
  tgk: "Tojikī",
  ber: "",
  hsb: "",
  uig: "",
  cym: "",
  sah: "",
  iii: "",
  bfi: "",
  isg: "",
  ncs: "",
  ewe: "",
  gaa: "Gã",
  twi: "",
  kri: "",
  fat: "",
  gan: "",
  fzho: "",
  hak: "",
  hokk1242: "",
  hsn: "",
  pcm: "",
  smo: "",
  ton: "",
  fij: "",
  tvl: "",
  tpi: "",
  gil: "",
  sna: "",
  grb: "",
  syr: "",
  ban: "",
  bis: "",
  ilo: "",
  nau: "",
  niu: "",
  pkp: "",
  sun: "Basa Sunda",
  tah: "",
  tkl: "",
  pag: "",
  nan: "",
  fcs: "",
  lat: "",
  hil: "",
  ace: "",
  ach: "",
  esu: "",
  xho: "",
  chao1238: "潮州話",
  ctd: "",
  zyp: "",
  kdh: "",
  din: "",
  dyo: "Jóola",
  bin: "",
  gex: "",
  gug: "",
  hain1238: "",
  har: "",
  mey: "",
  lom: "",
  clt: "",
  ziw: "",
  mkw: "",
  kik: "",
  jing1262: "",
  jra: "",
  lug: "Oluganda",
  luo: "Dholuo",
  ymm: "",
  mnk: "",
  mrh: "",
  hlt: "",
  myb: "",
  men: "",
  ium: "",
  hna: "",
  cnr: "",
  nus: "",
  wes: "",
  fuc: "",
  sez: "",
  chen1267: "",
  sus: "",
  bsq: "",
  cal: "",
  cha: "",
  cfm: "Laiṭong",
  als: "",
  brx: "",
  doi: "",
  kas: "",
  mni: "",
  sat: "",
  snd: "",
  tcs: "",
  ulk: "",
  wim: "",
  mwp: "",
  kky: "",
  pis: "",
  wmt: "",
  ggd: "",
  yuul1239: "",
  new: "",
  apa: "",
  beq: "",
  nya: "",
  sfs: "",
  nde: "",
  ssw: "",
  tso: "",
  ven: "",
  toi: "",
  tog: "",
  lua: "",
  mlg: "",
  lrl: "",
  mfz: "",
  tdt: "",
  ood: "",
  sag: "",
  tig: "",
  scn: "",
  nyn: "",
  kac: "",
  spy: "",
  kln: "",
  sgc: "",
  lan: "",
  enb: "",
  pko: "",
  kpz: "",
  axe: "",
  aly: "",
  eth: "",
  chat1268: "",
  rki: "",
  ade: "",
  bmb: "",
  bua: "",
  cre: "",
  dgr: "",
  kqo: "",
  gej: "",
  gom: "",
  pdu: "",
  tod: "",
  kxf: "",
  mls: "",
  dty: "",
  pau: "",
  pam: "",
  pif: "",
  krn: "",
  kvy: "",
  shn: "",
  czt: "",
  blt: "",
  bfz: "",
  rkm: "",
  agq: "",
  emk: "",
  aee: "",
  glh: "",
  psi: "",
  psh: "",
  ibg: "",
  lir: "",
  ssy: "",
  mlq: "",
  pap: "",
  tem: "",
  krw: "",
  waci1238: "",
  arc: "",
  krj: "",
  haw: "",
  raj: "",
  bete1265: "",
  dzo: "",
  bgc: "",
  bho: "",
  mfs: "",
  bzj: "",
  trf: "",
  limo1249: "",
  bjs: "",
  ktb: "",
  hfy: "",
  kab: "",
  mkj: "",
  hgm: "",
  dag: "",
  ryu: "",
  war: "",
  csf: "",
  nzi: "",
  csg: "",
  bzs: "",
  wuu: "",
  ouji1238: "",
  xiam1236: "",
  bhh: "",
  bai: "",
  nwe: "",
  mos: "",
  ssp: "",
  cbi: "",
  kno: "",
  kfr: "",
  tiv: "",
  byv: "",
  mwr: "",
  kqs: "",
  kss: "",
  gru: "",
  stv: "",
  zwa: "",
  ior: "",
  mvz: "",
  sgw: "",
  phr: "",
  aaa: "",
  gkn: "",
  wln: "",
  chim1312: "",
  ghl: "",
  pov: "",
  kcm: "",
  guz: "",
  nap: "Napulitano",
  ning1280: "",
  tsz: "",
  baju1245: "Kibajuni",
  lus: "",
  cab: "",
  tcf: "",
  tpc: "",
  tpl: "",
  tpx: "",
  ttc: "",
  nah: "",
  amu: "",
  azm: "",
  azg: "",
  czn: "",
  cly: "",
  cya: "",
  dyu: "",
  ymn: "Af- Mai-Mai",
  fuf: "Pular",
  kam: "",
  kxd: "",
  mol: "",
  dje: "",
  keo: "",
  aks: "",
  bod: "བོདསྐད",
  msa: "Bahasa Melayu",
};

export const i18nLanguages = [
  { val: "es", text: "Español", translation: "(Spanish)" },
  { val: "zh-hans", text: "简体中文", translation: "(Chinese - Simplified)" },
  { val: "zh-hant", text: "繁体中文", translation: "(Chinese - Traditional)" },
  { val: "en", text: "English" },
  { val: "fr", text: "Français", translation: "(French)" },
  { val: "de", text: "Deutsch", translation: "(German)" },
  { val: "it", text: "Italiano", translation: "(Italian)" },
  { val: "ja", text: "日本語", translation: "(Japanese)" },
  { val: "ko", text: "한국어", translation: "(Korean)" },
  { val: "pt", text: "Português", translation: "(Portuguese)" },
]

export const deleteAccountReasonsList = {
  reason1:"Don’t need it anymore",
  reason2:"Using a different interpreting service",
  reason3:"Didn’t work for me",
  reason4:"Costs too much",
  reason5:"Other"
}
export const STATUS_CHANGE_NOTIFICATION_TYPES = [
  'session:in-call',
  'session:off-call',
  'status:available',
  'status:unavailable',
]

export const langForDuration = {
"acr+spa":	"12 hours",
"eng+knj":	"12 hours",
"knj+spa":	"12 hours",
"ase+eng":	"12 hours",
"amh+eng":	"12 hours",
"aao+eng":	"12 hours",
"ara-arz_apd+eng": "12 hours",
"afb+eng":	"12 hours",
"acm+eng":	"12 hours",
"ara-apc_ajp+eng": "12 hours",
"arb+eng":	"12 hours",
"bam+eng":	"12 hours",
"ben+eng":	"12 hours",
"eng+mya":	"12 hours",
"ixj+spa":	"12 hours",
"eng+yue":	"12 hours",
"cmn+eng":	"12 hours",
"cac+spa":	"12 hours",
"eng+prs":	"12 hours",
"eng+pes":	"12 hours",
"eng+fra":	"12 hours",
"eng+guj":	"12 hours",
"eng+hat":	"12 hours",
"eng+hin":	"12 hours",
"eng+quc":	"12 hours",
"quc+spa":	"12 hours",
"eng+kin":	"12 hours",
"eng+mam":	"12 hours",
"mam+spa":	"12 hours",
"eng+ixi":	"12 hours",
"ixi+spa":	"12 hours",
"eng+npi":	"12 hours",
"eng+glh":	"12 hours",
"eng+orm":	"12 hours",
"eng+pus":	"12 hours",
"poc+spa":	"12 hours",
"poh+spa":	"12 hours",
"eng+por":	"12 hours",
"eng+por-br":"12 hours",
"eng+pan":	"12 hours",
"kjb+spa":	"12 hours",
"eng+kek":	"12 hours",
"kek+spa":	"12 hours",
"eng+rhg":	"12 hours",
"eng+rus":	"12 hours",
"ixl+spa":	"12 hours",
"eng+som":	"12 hours",
"eng+spa":	"12 hours",
"eng+swa":	"12 hours",
"eng+syl":	"12 hours",
"eng+tir":	"12 hours",
"eng+tur":	"12 hours",
"spa+tzo":	"12 hours",
"eng+ukr":	"12 hours",
"eng+urd":	"12 hours",
"eng+uzb":	"12 hours",
"eng+vie":	"12 hours",
"baju1245+eng":"2 weeks",
"ceb+eng":	"2 weeks",
"chao1238+eng":"2 weeks",
"eng+zho-cn-shang": "2 weeks",
"chk+eng":	"2 weeks",
"eng+luo":	"2 weeks",
"eng+gaa":	"2 weeks",
"eng+jac":	"2 weeks",
"dyo+eng":	"2 weeks",
"eng+kbp":	"2 weeks",
"eng+lug":	"2 weeks",
"eng+ymn":	"2 weeks",
"eng+mkd":	"2 weeks",
"eng+zsm":	"2 weeks",
"eng+mah":	"2 weeks",
"eng+mon":	"2 weeks",
"nah+spa":	"2 weeks",
"eng+nap":	"2 weeks",
"eng+pon":	"2 weeks",
"que+spa":	"2 weeks",
"qvi+spa":	"2 weeks",
"eng+rom":	"2 weeks",
"eng+slk":	"2 weeks",
"eng+sun":	"2 weeks",
"eng+tel":	"2 weeks",
"spa+tzj":	"2 weeks",
"spa+yua":	"2 weeks",
"aka+eng":	"24 hours",
"eng+sqi":	"24 hours",
"arm+eng":	"24 hours",
"bul+eng":	"24 hours",
"eng+ixj":	"24 hours",
"fra+hat":	"24 hours",
"hat+spa":	"24 hours",
"eng+hau":	"24 hours",
"eng+ind":	"24 hours",
"eng+ita":	"24 hours",
"jac+spa":	"24 hours",
"eng+jpn":	"24 hours",
"eng+ksw":	"24 hours",
"eng+kor":	"24 hours",
"eng+kur":	"24 hours",
"eng+lin":	"24 hours",
"mixt1427+spa":"24 hours",
"aee+eng":	"24 hours",
"eng+kmr":	"24 hours",
"por+spa":	"24 hours",
"eng+kjb":	"24 hours",
"eng+ron":	"24 hours",
"eng+ixl":	"24 hours",
"eng+srp":	"24 hours",
"eng+psi":	"24 hours",
"eng+tgl":	"24 hours",
"eng+tgk":	"24 hours",
"eng+tam":	"24 hours",
"eng+tha":	"24 hours",
"eng+twi":	"24 hours",
"eng+wol":	"24 hours",
"eng+yor":	"24 hours",
"CD":"48 hours",
"agu+spa":	"48 hours",
"bzj+eng":	"48 hours",
"bos+eng":	"48 hours",
"eng+kea":	"48 hours",
"eng+zho-tw":"48 hours",
"ces+eng":	"48 hours",
"eng+fil":	"48 hours",
"fra+spa":	"48 hours",
"eng+gcr":	"48 hours",
"eng+ful":	"48 hours",
"cab+spa":	"48 hours",
"eng+gex":	"48 hours",
"eng+kat":	"48 hours",
"deu+eng":	"48 hours",
"ell+eng":	"48 hours",
"bgc+eng":	"48 hours",
"eng+heb":	"48 hours",
"eng+hmn":	"48 hours",
"eng+hun":	"48 hours",
"cak+eng":	"48 hours",
"cak+spa":	"48 hours",
"eng+khm":	"48 hours",
"eng+run":	"48 hours",
"eng+lao":	"48 hours",
"eng+pol":	"48 hours",
"eng+fuc":	"48 hours",
"eng+kri":	"48 hours",
"spa+usp":	"48 hours",
"eng+mlq":	"48 hours",
"chat1268+spa":"72 hours",
"eng+fzho":"72 hours",
"eng+kdh":	"72 hours",
"eng+hrv":	"72 hours",
"cfm+eng":	"72 hours",
"eng+fra-ca":"72 hours",
"cnh+eng":	"72 hours",
"eng+jam":	"72 hours",
"eky+eng":	"72 hours",
"czn+spa":	"72 hours",
"eng+nor":	"72 hours",
"spa+triq1251":"72 hours", 
"spa+tzh":	"72 hours",
"eng+yua":	"72 hours",
"spa+zap":	"72 hours",
}
